module["exports"] = [
  "Dr.",
  "Prof.",
  "PhD."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/name/prefix.js
// module id = 1765
// module chunks = 1